import { defineConfig } from "@chakra-ui/react/styled-system";
import {
  // Slot recipes (used components only)
  accordionSlotRecipe,
  actionBarSlotRecipe,
  alertSlotRecipe,
  animationStyles,
  avatarSlotRecipe,
  // Simple recipes (used components only)
  badgeRecipe,
  blockquoteSlotRecipe,
  breakpoints,
  buttonRecipe,
  cardSlotRecipe,
  slotRecipes as chakraSlotRecipes,
  checkboxSlotRecipe,
  checkmarkRecipe,
  codeRecipe,
  collapsibleSlotRecipe,
  colorPickerSlotRecipe,
  colorSwatchRecipe,
  comboboxSlotRecipe,
  dataListSlotRecipe,
  dialogSlotRecipe,
  drawerSlotRecipe,
  editableSlotRecipe,
  emptyStateSlotRecipe,
  fieldSlotRecipe,
  fieldsetSlotRecipe,
  fileUploadSlotRecipe,
  globalCss,
  headingRecipe,
  hoverCardSlotRecipe,
  iconRecipe,
  inputRecipe,
  keyframes,
  layerStyles,
  linkRecipe,
  listSlotRecipe,
  menuSlotRecipe,
  nativeSelectSlotRecipe,
  numberInputSlotRecipe,
  pinInputSlotRecipe,
  popoverSlotRecipe,
  progressCircleSlotRecipe,
  progressSlotRecipe,
  radioCardSlotRecipe,
  radioGroupSlotRecipe,
  radiomarkRecipe,
  ratingGroupSlotRecipe,
  segmentGroupSlotRecipe,
  selectSlotRecipe,
  semanticTokens,
  separatorRecipe,
  skeletonRecipe,
  sliderSlotRecipe,
  spinnerRecipe,
  splitterSlotRecipe,
  statSlotRecipe,
  statusSlotRecipe,
  stepsSlotRecipe,
  switchSlotRecipe,
  tableSlotRecipe,
  tabsSlotRecipe,
  tagSlotRecipe,
  tagsInputSlotRecipe,
  textStyles,
  textareaRecipe,
  timelineSlotRecipe,
  toastSlotRecipe,
  tokens,
  tooltipSlotRecipe,
  treeViewSlotRecipe,
} from "@chakra-ui/react/theme";

const defaultTheme = defineConfig({
  preflight: true,
  cssVarsPrefix: "chakra",
  cssVarsRoot: ":where(html, .chakra-theme)",
  globalCss: {
    ...globalCss,
    html: {
      ...globalCss?.html,
      fontSize: "clamp(14px, 1vw, 16px)",
    },
  },
  theme: {
    breakpoints,
    keyframes,
    tokens,
    semanticTokens,
    textStyles,
    layerStyles,
    animationStyles,
    recipes: {
      badge: badgeRecipe,
      button: buttonRecipe,
      checkmark: checkmarkRecipe,
      code: codeRecipe,
      colorSwatch: colorSwatchRecipe,
      heading: headingRecipe,
      icon: iconRecipe,
      input: inputRecipe,
      link: linkRecipe,
      radiomark: radiomarkRecipe,
      separator: separatorRecipe,
      skeleton: skeletonRecipe,
      spinner: spinnerRecipe,
      textarea: textareaRecipe,
    },
    slotRecipes: {
      accordion: accordionSlotRecipe,
      actionBar: actionBarSlotRecipe,
      alert: alertSlotRecipe,
      avatar: avatarSlotRecipe,
      blockquote: blockquoteSlotRecipe,
      card: cardSlotRecipe,
      checkbox: checkboxSlotRecipe,
      collapsible: collapsibleSlotRecipe,
      colorPicker: colorPickerSlotRecipe,
      combobox: comboboxSlotRecipe,
      dataList: dataListSlotRecipe,
      dialog: dialogSlotRecipe,
      drawer: drawerSlotRecipe,
      editable: editableSlotRecipe,
      emptyState: emptyStateSlotRecipe,
      field: fieldSlotRecipe,
      fieldset: fieldsetSlotRecipe,
      fileUpload: fileUploadSlotRecipe,
      floatingPanel: chakraSlotRecipes.floatingPanel,
      hoverCard: hoverCardSlotRecipe,
      list: listSlotRecipe,
      menu: menuSlotRecipe,
      nativeSelect: nativeSelectSlotRecipe,
      numberInput: numberInputSlotRecipe,
      pinInput: pinInputSlotRecipe,
      popover: popoverSlotRecipe,
      progress: progressSlotRecipe,
      progressCircle: progressCircleSlotRecipe,
      radioCard: radioCardSlotRecipe,
      radioGroup: radioGroupSlotRecipe,
      ratingGroup: ratingGroupSlotRecipe,
      segmentGroup: segmentGroupSlotRecipe,
      select: selectSlotRecipe,
      slider: sliderSlotRecipe,
      splitter: splitterSlotRecipe,
      stat: statSlotRecipe,
      status: statusSlotRecipe,
      steps: stepsSlotRecipe,
      switch: switchSlotRecipe,
      table: tableSlotRecipe,
      tabs: tabsSlotRecipe,
      tag: tagSlotRecipe,
      tagsInput: tagsInputSlotRecipe,
      toast: toastSlotRecipe,
      tooltip: tooltipSlotRecipe,
      treeView: treeViewSlotRecipe,
      timeline: timelineSlotRecipe,
    },
  },
});

export default defaultTheme;
